module.exports = __webpack_public_path__ + "static/media/breakfast.54c152a2.svg";